import { createContext, useState } from "react";

export const store = createContext()

const Provider = ({
    children
}) => {
    const [logo, setLogo] = useState("");
    const [clientData, setClientData] = useState([]);
    const [vertical, setVertical] = useState([]);
    const [cart, setcart] = useState(0);
    const [cartamount, setcartamount] = useState(0);
    const [banner, setBanner] = useState([]);
    const [cartItems, setCartItems] = useState([]) // newly added to track the cart data
    const [cartData, setCartData] = useState([]); //for cart page

    //////////////////////////////////////////// personalized states ////////////////////////////////////////
    const [customOccasion, setCustomOccasion] = useState("");
    const [receiverName, setReceiverName] = useState("");
    const [customText, setCustomText] = useState("");
    const [senderName, setSenderName] = useState("");
    const [occasionId, setOccasionId] = useState(null);
    const [personalisation, setPersonalisation] = useState(false);
    //////////////////////////Personalized states end here //////////////////////////////////////////////////


    const [showPincodeModal, setShowPincodeModal] = useState(false);
    const [pincode, setPincode] = useState(null);
    const [currentPage, setCurrentPage] = useState("Home");
    const [loggedIn, setLoggedIn] = useState(false);
    const [siteHeader, setSiteHeader] = useState([]);
    const [category4Data, setCategory4Data] = useState([]);
    const [category3Data, setCategory3Data] = useState([]);
    const [storeStatus, setStoreStatus] = useState("");
    const [lat, setLat] = useState(null);
    const [lng, setLang] = useState(null);
    const [mapPositionMarkerLat, setmapPostitionMarkerLat] = useState(null);
    const [mapPositionMarkerLng, setmapPostitionMarkerLang] = useState(null);
    const [mapAddress, setMapAddress] = useState(null);
    const [homeLocationModal, setHomeLocationModal] = useState(false);
    const [selectedBillAddress, setSelectedBillAddress] = useState(false);
    const [greetOptions, setGreetOptions] = useState(false);
    const [pincodes, setPinCodes] = useState([]) // delivery pincodes
    const [selectedPincode, setSelectedPincode] = useState(null);
    const [showSearchBar, setShowSearchBar] = useState(false);

    const [totalOrders, setTotalOrders] = useState("")
    return (
        <store.Provider value={{
            vertical, setVertical,
            cart, setcart, cartamount, setcartamount, currentPage, setCurrentPage, banner, setBanner, logo, setLogo,
            showPincodeModal, setShowPincodeModal,
            pincode, setPincode,
            clientData, setClientData,
            loggedIn, setLoggedIn,
            siteHeader,
            setSiteHeader,
            cartItems, setCartItems,
            category4Data, setCategory4Data,
            category3Data, setCategory3Data,
            cartData, setCartData,
            storeStatus, setStoreStatus,
            lat, setLat,
            lng, setLang,
            mapPositionMarkerLat, setmapPostitionMarkerLat,
            mapPositionMarkerLng, setmapPostitionMarkerLang,
            mapAddress, setMapAddress,
            homeLocationModal, setHomeLocationModal,
            selectedBillAddress, setSelectedBillAddress,
            greetOptions, setGreetOptions,
            customOccasion, setCustomOccasion,
            receiverName, setReceiverName,
            customText, setCustomText,
            senderName, setSenderName,
            occasionId, setOccasionId,
            personalisation, setPersonalisation,
            pincodes, setPinCodes,
            selectedPincode, setSelectedPincode,
            totalOrders, setTotalOrders,
            showSearchBar, setShowSearchBar
        }}>
            {children}
        </store.Provider>
    )
}

export default Provider;